import * as React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { clientApi } from '../../../../../api/clientApi';
import { NoNavigationPageWrapper } from '../../../../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { SingleColumnLayout } from '../../../../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../../../designSystem/PageHeader';
import { PublicPageProvider } from '../../../../_contexts/PublicPageContext';
import { P } from '../../../../../designSystem/typography/Body';

// type loginMethod = 'none' |'magicLink';

export function PortalLoginConfirmPage(): JSX.Element {
    
    const params = useParams<{ siteId:string, email:string, requestId:string }>();

    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState<boolean | null>(null);

    React.useEffect(() => {
        async function getData() {
            const result = await clientApi.portal.confirmMagicLink(params.siteId, params.email, params.requestId);
            setSuccess(result);
            setLoading(false);
        }
        getData();
    },[params.siteId, params.email, params.requestId]);

    return (
        <PublicPageProvider>
            <NoNavigationPageWrapper>

                {loading &&
                    <LoadingPageOverlay loading={true} />
                }

                {success 
                    
                    ?
                    <Redirect to={`/portal/${params.siteId}`} />

                    :
                    <SingleColumnLayout
                        noDivider
                        headerContainer={
                            <PageHeader headerText="Bekræft login" headerStyle='primary-black' />
                        }
                        contentContainer={
                            <>
                                <P>Vi kunne ikke logged dig ind.</P>
                                
                                <P>Det kan skyldes at linket er udløbet, eller at det er blevet brugt tidligere. Prøv at anmode om et nyt link, og klik på det seneste link du modtager i din email.</P>
                            </>
                        }
                    />
                }
            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}